"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

var getCookieValue = function getCookieValue(cookieName) {
  return document.cookie.replace(new RegExp("(?:(?:^|.*;\\s*)".concat(cookieName, "\\s*=\\s*([^;]*).*$)|^.*$")), '$1');
};

var _default = getCookieValue;
exports.default = _default;